export const PAYABLE_ENTITY_LABEL = "Payable";
export const PAYABLE_ENTITY_LABEL_PLURAL = "Payables";
/** Lower-case form, for the middle of a sentence. */
export const PAYABLE_ENTITY_LABEL_PLURAL_LOWER = "payables";

export const PAYABLE_BATCH_DELETE_DESCRIPTION =
  "This batch has line items but no payables or deductions are created yet.";
export const PAYABLE_BATCH_DELETE_EMPTY_DESCRIPTION =
  "This batch is empty. No payable or line items are imported yet.";
